import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* getCODMaxAmountSuccess() {
  yield takeEvery(actionTypes.GET_COD_MAX_AMOUNT, function* (action) {
    try {
      const response = yield API.getCODMaxAmount();
      //   console.log(response);
      if (response.data.success) {
        yield put(actions.getCODMaxAmountSuccess(response.data.data));
      } else {
        yield put(actions.getCODMaxAmountFail());
      }
    } catch (error) {
      yield put(actions.getCODMaxAmountFail());
    }
  });
}

export function* restaurantDirectCheckout() {
  yield takeEvery(actionTypes.RESTAURANT_DIRECT_CHECKOUT, function* (action) {
    yield put(actions.enableLoading());
    try {
      if (action.isCOD === true) {
        const response = yield API.restaurantDirectCheckoutCOD(action.data);
        if (response.data.success) {
          yield put(
            actions.restaurantDirectCheckoutSuccess(response.data.data)
          );
        } else {
          yield put(
            actions.restaurantDirectCheckoutFail(response.data.message)
          );
        }
      } else {
        const response = yield API.restaurantDirectCheckout(action.data);
        if (response.data.success) {
          yield put(
            actions.restaurantDirectCheckoutSuccess(response.data.data)
          );
        } else {
          yield put(
            actions.restaurantDirectCheckoutFail(response.data.message)
          );
        }
      }
      yield put(actions.disableLoading());
    } catch (error) {
      // alert(actions.handleAPIError(error, "Fail to direct checkout."));
      yield put(actions.restaurantDirectCheckoutFail(error.response.data));
      yield put(actions.disableLoading());
    }
  });
}

export function* checkRiderAvailability() {
  yield takeEvery(actionTypes.CHECK_RIDER_AVAILABILITY, function* () {
    try {
      const response = yield API.checkRiderAvailability();
      if (response.data.success) {
        yield put(actions.checkRiderAvailabilitySuccess(response.data.data));
      } else {
        yield put(actions.checkRiderAvailabilityFail(response.data.message));
      }
    } catch (error) {
      yield put(actions.checkRiderAvailabilityFail(error.response.data));
    }
  });
}

export function* checkOrderTypeAndTime() {
  yield takeEvery(actionTypes.CHECK_ORDER_TYPE_AND_TIME, function* (action) {
    try {
      const response = yield API.checkOrderTypeAndTime(action.data);
      if (response.data.success) {
        yield put(actions.checkOrderTypeAndTimeSuccess(response.data));
      } else {
        yield put(actions.checkOrderTypeAndTimeFail(response.data));
      }
    } catch (error) {
      yield put(actions.checkOrderTypeAndTimeFail(error.response.data));
    }
  });
}

export function* loadAvailableOrderingTime() {
  yield takeEvery(actionTypes.LOAD_AVAILABLE_ORDER_TIME, function* (action) {
    try {
      const response = yield API.availableOrderingTime(action.data);
      if (response.data.success) {
        yield put(actions.loadAvailableOrderTimeSuccess(response.data));
      } else {
        if (response.data.message !== undefined) alert(response.data.message);
        yield put(actions.loadAvailableOrderTimeFail(response.data));
      }
    } catch (error) {
      if (error.response.data.message !== undefined)
        alert(error.response.data.message);
      yield put(actions.loadAvailableOrderTimeFail(error.response.data));
    }
  });
}

export function* getDeliveryETA() {
  yield takeEvery(actionTypes.GET_DELIVERY_ETA, function* (action) {
    try {
      const response = yield API.getDeliveryETA(action.data);
      if (response.data.success) {
        yield put(actions.getDeliveryETASuccess(response.data));
      } else {
        yield put(actions.getDeliveryETAFail());
      }
    } catch (error) {
      yield put(actions.getDeliveryETAFail());
    }
  });
}

export function* getSpecialArea() {
  yield takeEvery(actionTypes.GET_SPECIAL_AREA, function* (action) {
    try {
      const response = yield API.getSpecialArea(action.data);
      if (response.data.success) {
        yield put(actions.getSpecialAreaSuccess(response.data));
      } else {
        yield put(actions.getSpecialAreaFail());
      }
    } catch (error) {
      yield put(actions.getSpecialAreaFail());
    }
  });
}

export function* dineInPayLater() {
  yield takeEvery(actionTypes.RESTAURANT_DINE_IN_PAY_LATER, function* (action) {
    try {
      const response = yield API.dineInPayment(action.data);
      if (response.data.success) {
        yield put(actions.dineInPayLaterSuccess(response.data));
      } else {
        alert("Warning: Fail to make payment. \n" + response.data.message);
        yield put(actions.dineInPayLaterFail(response.data.message));
      }
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.dineInPayLaterFail("Fail"));
    }
  });
}

export default function* orderSaga() {
  yield all([
    fork(getCODMaxAmountSuccess),
    fork(restaurantDirectCheckout),
    fork(checkRiderAvailability),
    fork(checkOrderTypeAndTime),
    fork(loadAvailableOrderingTime),
    fork(getDeliveryETA),
    fork(getSpecialArea),
    fork(dineInPayLater),
  ]);
}
